import React from "react";
import { Chip } from "@mui/material";

interface CustomBadgeProps {
  color?: 'success' | 'primary' | 'info' | 'default';
  children: React.ReactNode;
}

const colorMap = {
  success: {
    background: '#D1FADF',
    color: '#039855',
  },
  primary: {
    background: '#F4F3FF',
    color: '#7A5AF8',
  },
  info: {
    background: '#EEF4FF',
    color: '#444CE7',
  },
  default: {
    background: '#F3F4F6',
    color: '#6B7280',
  },
};

export function Badge({ color = 'default', children }: CustomBadgeProps) {
  return (
    <Chip
      label={children}
      size="small"
      sx={{
        background: colorMap[color].background,
        color: colorMap[color].color,
        fontWeight: 700,
        fontSize: 13,
        borderRadius: 1.5,
        px: 1.5,
        height: 28,
        letterSpacing: 0.1,
      }}
    />
  );
}